"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactI18next = require("react-i18next");

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _Image = _interopRequireWildcard(require("../Image"));

var _Button = _interopRequireDefault(require("../Button"));

var _LottieAnimate = _interopRequireDefault(require("../LottieAnimate"));

var MAX_DISPLAY_EMAIL = 2;

var AccountLoading = function AccountLoading(_ref) {
  var onClose = _ref.onClose,
      onClick = _ref.onClick,
      emails = _ref.emails;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var emailsText = (0, _react.useMemo)(function () {
    if (emails.length > MAX_DISPLAY_EMAIL) {
      return "".concat(emails.slice(0, MAX_DISPLAY_EMAIL).join(', '), " +").concat(emails.length - MAX_DISPLAY_EMAIL, " others");
    } else if (emails.length > 1) {
      return [emails.slice(0, emails.length - 1).join(', '), emails.slice(emails.length - 1)].join(' & ');
    } else {
      return emails[0];
    }
  }, [emails]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col p-12 relative"
  }, onClose && /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute right-0 top-0 pt-5 pr-5"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "rounded-full hover:bg-secondary hover:shadow-hover p-2 flex items-center text-light hover:text-medium",
    onClick: onClose
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], null))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-full md:w-2/3 mx-auto"
  }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
    width: "1001",
    height: "370",
    className: "w-full",
    alt: "account-loading.png",
    src: (0, _Image.withThemeSrc)(t('retrofit.syncProgress.loading.image'), t('retrofit.syncProgress.loading.image.dark'))
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "relative h-20 w-full overflow-hidden"
  }, /*#__PURE__*/_react["default"].createElement(_LottieAnimate["default"], {
    loop: true,
    path: t('loading-dots.json'),
    className: "absolute w-48",
    style: {
      left: '50%',
      transform: 'translate(-6rem, -25%)'
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-2xl text-gray-dark font-bold leading-loose"
  }, t('retrofit.syncProgress.loading.title', {
    emails: emailsText
  })), /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-gray-light mt-4"
  }, t('retrofit.syncProgress.loading.subtitle')), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-10"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "text-primary font-bold",
    onClick: onClick
  }, t('retrofit.success.importAnother'))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-10"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: "w-64",
    onClick: onClose
  }, t('button.goToInbox')))));
};

var _default = AccountLoading;
exports["default"] = _default;
//# sourceMappingURL=AccountLoading.js.map